<h3 mat-dialog-title>Alterar Valor</h3>
<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div fxFlex.gt-sm="100%">
            <mat-form-field style="width: 100%" appearance="outline" floatLabel="always">
                <input 
                    matInput 
                    required
                    placeholder="Valor" 
                    [formControl]="valor"                     
                    maxlength="50"
                    currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                >
                <mat-error *ngIf="valor.invalid">{{getErrorValorMessage()}}</mat-error>
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    
    <button 
        mat-button 
        [disabled]="isInvalidForm()" 
        (click)="validaFormulario()" 
        tabindex="-1"
    >
        Salvar
    </button>
</div>